export default __webpack_public_path__ + "static/media/wechat_qr.50f33977.jpg";